// Pages/ProductPage.jsx
import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import axios from "axios";
import Constants from "../Utilities/Constants";
import ProductDetails from "../Components/ProductDetails";
import SideBarGallery from "../Components/SideBar";
import Breadcrumb from "../Components/Breadcrumb";
import { usePageTitle } from "../Utilities/usePageTitle";

export default function ProductPage() {
  const { productUrl } = useParams();
  const location = useLocation();
  const [productName, setProductName] = useState("");

  useEffect(() => {
    let mounted = true;
    const fetchName = async () => {
      try {
        const url = `${Constants.API_URL_GET_PRODUCT}/${productUrl}`;
        const resp = await axios.get(url);
        if (mounted) setProductName(resp.data?.productName || "");
      } catch (err) {
        // ignore
      }
    };
    fetchName();
    return () => { mounted = false; };
  }, [productUrl]);

  usePageTitle(productName);
  const { category, subcategory } = location.state || {};

  const breadcrumbItems = [
    { label: 'דף הבית', path: '/' },
  ];

  if (category) breadcrumbItems.push({ label: category, path: `/category/${encodeURIComponent(category)}` });
  if (subcategory) breadcrumbItems.push({ label: subcategory, path: `/category/${encodeURIComponent(category)}/${encodeURIComponent(subcategory)}` });
  if (productName) breadcrumbItems.push({ label: productName, path: `/product/${productUrl}` });

  return (
    <>
      <div className="container py-2">
        <div className="row">
          <div className="col-md-2 text-center desktop">
            <div className="d-flex flex-wrap justify-content-around w-100">
              <SideBarGallery />
            </div>
          </div>
          <div className="col-md-10">
            <Breadcrumb items={breadcrumbItems} />
            <ProductDetails layout="page" />
          </div>
        </div>
      </div>
    </>
  );
}
